interface IAppConst {
    headerHeight: number,
    baseApiURL: string,
    OIDC_AUTHORITY: string,
    OIDC_CLIENT_ID: string,
    OIDC_REDIRECT_URI: string,
    OIDC_CLIENT_SECRET: string,
}
export const appConst: IAppConst = {
    headerHeight: 56,
    baseApiURL: process.env.REACT_APP_API_BASE_URL?.toString() ?? "",
    OIDC_AUTHORITY: process.env.REACT_APP_OIDC_AUTHORITY?.toString() ?? "",
    OIDC_CLIENT_ID: process.env.REACT_APP_OIDC_CLIENT_ID?.toString() ?? "",
    OIDC_CLIENT_SECRET: process.env.REACT_APP_OIDC_CLIENT_SECRET?.toString() ?? "",
    OIDC_REDIRECT_URI: process.env.REACT_APP_OIDC_REDIRECT_URI?.toString() ?? "",
}
